<app-header [navItems]="navItems">
  <div subtitle>{{ 'chargeInformation.title' | translate }}</div>
  @if (chargeInformation) {
    <div title>
      {{ chargeInformation.chargeTypeId || '-' }}
    </div>
  }
</app-header>

<div class="pane-wrapper">
  <router-outlet></router-outlet>
</div>
